import { DescriptionText, H1Text, H2Text } from "../../../../design";
import React from "react";
import { AmountDivideByHundred } from "../../../../helper";
import SmallScreenHeader from "../../../../components/smallscreen/header";
import currencyformatter from "../../../../utils/currencyformatter";

type Props = {
  transferLink: Object,
  bankImageUrl: String,
}

const Header = (props: Props) => {
  const { transferLink, bankImageUrl } = props;
  const largeLogo = (transferLink && transferLink.account && transferLink.account.largeLogo) ? transferLink.account.largeLogo : null;
  return (
    <SmallScreenHeader paymentCheckout={true} bankImageUrl={bankImageUrl} largeLogo={largeLogo}>
      <H1Text>
        Transfer Link
      </H1Text>
      <H2Text>
        Transfer From
      </H2Text>
      <DescriptionText>
        {(transferLink) && (transferLink.account) && (transferLink.account.name)}
      </DescriptionText>
      <H2Text>
        Transfer Description
      </H2Text>
      <DescriptionText>
        {transferLink && transferLink.description}
      </DescriptionText>
      <H2Text>
        Amount Payable
      </H2Text>
      <DescriptionText fontSize="24px">
        {transferLink ? `${currencyformatter(AmountDivideByHundred(transferLink.amount), transferLink.currency && transferLink.currency.name)}` : null}
      </DescriptionText>
    </SmallScreenHeader>
  )
};

export default Header;
